import React from 'react'
import Nav from 'react-bootstrap/lib/Nav'
import Navbar from 'react-bootstrap/lib/Navbar'
import NavDropdown from 'react-bootstrap/lib/NavDropdown'
import NavItem from 'react-bootstrap/lib/NavItem'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import { Link } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { FormattedMessage, injectIntl } from 'react-intl'
import LanguageSelector from './LanguageSelector'
import NetworkSelector from './NetworkSelector'
import logoImg from '../../img/bantu_logo_transparent_white.png'
import ToggleDarkMode from '../DarkModeToggle'
import { getDynamicBackgroundColor, getHexColor } from "../common/color_utils";

class Header extends React.Component {
  render() {
    const { formatMessage } = this.props.intl
    return (
      <Navbar fixedTop collapseOnSelect className="header-bantu">
        <Navbar.Header>
          <Navbar.Brand>
            {/* <Link to="/">
              <span> <img src={logoImg} height='41' width='41' alt='Bantu Logo'/> </span>
            </Link>
            <span class="so-logo__separator"></span> */}
            <Link to="/">
              <span className="brand-text">{window._env_.APP_NAME} Explorer</span>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Navbar.Form pullRight>
            <LanguageSelector
              language={this.props.language}
              switcher={this.props.languageSwitcher}
            />
          </Navbar.Form>
          {/* <Navbar.Form pullRight>
            <NetworkSelector
              networkAddress={this.props.networkAddress}
              networkType={this.props.networkType}
              switchNetworkType={this.props.switchNetworkType}
              setNetworkAddress={this.props.setNetworkAddress}
            />
          </Navbar.Form> */}
          <Nav>
            {/* <LinkContainer to="/graphs">
              <NavItem>Graphs (beta)</NavItem>
            </LinkContainer> */}
            <LinkContainer to="/operations">
              <NavItem>
                <FormattedMessage id="operations" />
              </NavItem>
            </LinkContainer>
            <LinkContainer to="/txs">
              <NavItem>
                <FormattedMessage id="transactions" />
              </NavItem>
            </LinkContainer>
            <LinkContainer to="/ledgers">
              <NavItem>
                <FormattedMessage id="ledgers" />
              </NavItem>
            </LinkContainer>

            <li className="divider-vertical" />

            <NavDropdown
              eventKey={3}
              title={formatMessage({ id: 'more' })}
              id="basic-nav-dropdown"
            >
              <LinkContainer to="/effects">
                <MenuItem>
                  <FormattedMessage id="effects" />
                </MenuItem>
              </LinkContainer>
              <LinkContainer to="/payments">
                <MenuItem>
                  <FormattedMessage id="payments" />
                </MenuItem>
              </LinkContainer>
              <LinkContainer to="/trades">
                <MenuItem>
                  <FormattedMessage id="trades" />
                </MenuItem>
              </LinkContainer>
            </NavDropdown>
            <ToggleDarkMode />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }

  componentDidMount() {
    this.updateStylesManually();
  }

  componentDidUpdate() {
    this.updateStylesManually();
  }

  updateStylesManually() {
    try {
      const root = document.documentElement;
      root.style.setProperty("--brand-color", getHexColor());
    } catch (e) { }
  }
}

export default injectIntl(Header)



// WEBPACK FOOTER //
// ./src/components/layout/Header.js